var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('h3',[_vm._v(_vm._s(_vm.$t('adminHomePage.deviceModel')))]),_c('div',{staticClass:"wrap-ech"},[_c('v-chart',{attrs:{"options":_vm.opt,"autoresize":""}}),(!_vm.chartData.length)?_c('div',{staticClass:"no-data"},[_vm._v(_vm._s(_vm.$t('noData')))]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }